import { boronClient } from "../../api";
import { useBoronMutation } from "../../hooks/http/useBoronMutation";
import { useUpdateSkillsCache } from "../../hooks/http/useFetchSkills";
import { StudyRecordSkillParamsInterface } from "../../interfaces/StudyRecordSkillInterface";
import { useUpdateSkillCache } from "./useFetchSkill";

export const useUpdateSkill = ({
  sectionId,
  skillId,
}: {
  sectionId: string;
  skillId: string;
}) => {
  const { updateSkillCache } = useUpdateSkillCache({ sectionId, skillId });
  const { updateSkillsCache } = useUpdateSkillsCache({ sectionId });

  return useBoronMutation(
    async (params: StudyRecordSkillParamsInterface) =>
      await boronClient.PATCH(
        "/api/v1/sections/{section_id}/skills/{skill_hashid}",
        {
          params: {
            path: {
              section_id: sectionId,
              skill_hashid: skillId,
            },
          },
          body: {
            name: params.name,
            description: params.description,
            arguments: params.arguments,
          },
        },
      ),
    {
      onSuccess: (_, variables) => {
        // PATCHは204を返すため、送信したパラメータを使ってキャッシュを更新
        const updatedSkill = {
          id: skillId,
          name: variables.name,
          description: variables.description,
          arguments: {
            tagId: variables.arguments.tag_id,
            period: variables.arguments.period,
            value: variables.arguments.value,
            operator: variables.arguments.operator,
            message: variables.arguments.message,
            messageIgnoranceDays: variables.arguments.message_ignorance_days,
            smartTag: variables.arguments.smart_tag,
          },
        };

        // 単一のスキルのキャッシュを更新
        updateSkillCache(updatedSkill);
        // スキル一覧のキャッシュを更新
        updateSkillsCache(updatedSkill);
      },
    },
  );
};
